// Utility to detect react-snap prerender environment
// react-snap sets userAgent to "ReactSnap" in the prerendering browser
export function isPrerendering(): boolean {
  try {
    if (typeof navigator !== 'undefined') {
      const ua = (navigator.userAgent || '').toLowerCase();
      if (ua === 'reactsnap'.toLowerCase()) return true;
    }
    // Heuristic: some builds expose a marker on window after react-snap render
    if (typeof window !== 'undefined' && (window as any).reactSnapRenderTime != null) {
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}

export const IS_PRERENDER = isPrerendering();

